import { createFileRoute, redirect } from '@tanstack/react-router'

// Old URL kept alive for existing links; the offer lives at /call.
export const Route = createFileRoute('/coaching')({
  beforeLoad: () => {
    throw redirect({ to: '/call', statusCode: 301 })
  },
})
